"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createClass"));

var _collection = _interopRequireDefault(require("../react/collection.jsx"));

var StaticReactCollection =
/*#__PURE__*/
function () {
  function StaticReactCollection(section) {
    (0, _classCallCheck2["default"])(this, StaticReactCollection);
    this.collection = new _collection["default"](JSON.parse(document.querySelector('[data-collection-json]').innerHTML), section.el.querySelector('#react-collection'));
  }

  (0, _createClass2["default"])(StaticReactCollection, [{
    key: "onSectionUnload",
    value: function onSectionUnload() {
      this.collection.destructor();
    }
  }]);
  return StaticReactCollection;
}();

exports["default"] = StaticReactCollection;